'use strict';
var React = require('react');
var BaseComponent = require('../../../../../shared/base');

class FeatureCreateInvoiceB2bComponent extends BaseComponent {
    render() {
        return (
            <React.Fragment>
                <div />
            </React.Fragment>
        );
    }
}

module.exports = FeatureCreateInvoiceB2bComponent;